<template>
<div class="chapter">
<div class="inner_page">
<h1 class="BookTitle">Elmer Gantry</h1>
<h2 class="BookSubtitle">A Novel</h2>
<p class="author" style="margin-top:60px;">Sinclair Lewis</p>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ElmerGantry-2.vue?a4e38840